import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { AdminMessagesTable } from "../admin-messages/list/components/AdminMessagesTable/AdminMessagesTable";
import WithAjax from "../common/helpers/WithAjax";

export const VacancyAdminMessagesTab = (props) => {
  return (
    <div>
      <AdminMessagesTable ajax={props.ajax} initialFilter={{ VacancyId: props.vacancyId }} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});
export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WithAjax(VacancyAdminMessagesTab));
